import { shallowRef } from 'vue'

export function useMentionList() {
  const mentionList = shallowRef<Array<{ startIndex: number; length: number; userId: string }>>([])
  const insertMentionUser = (
    mention: { startIndex: number; length: number; userId: string },
    offset: number
  ) => {
    const originalMentionList = mentionList.value
    const insertIndex = originalMentionList.findIndex(
      mentionItem => mentionItem.startIndex > mention.startIndex
    )
    if (insertIndex === -1) {
      mentionList.value = [...originalMentionList, mention]
      return
    }

    mentionList.value = [
      ...originalMentionList.slice(0, insertIndex),
      mention,
      ...originalMentionList.slice(insertIndex).map(mention => {
        mention.startIndex = mention.startIndex + offset
        return mention
      })
    ]
  }
  const shouldRemoveWholeMention = (pattern: string, prefix: string, cursor: number) => {
    return mentionList.value.some(mention => {
      return mention.startIndex + mention.length + 1 === cursor
    })
  }
  const getFirstNeedRemoveIndex = (params: {
    value: string
    isDelete: boolean
    selectionStart: number
    cursor: number
  }) => {
    const { value, isDelete, selectionStart, cursor } = params
    let index = mentionList.value.findLastIndex(mention => {
      const { startIndex, length } = mention
      const endIndex = startIndex + length
      return endIndex <= selectionStart
    })
    // 支持在尾部插入空格
    if (index > -1 && !isDelete) {
      const { startIndex, length } = mentionList.value[index]
      const endIndex = startIndex + length
      if (value[endIndex] !== ' ') {
        index = index - 1
      }
    }
    return index + 1
  }
  const modifyMentionList = (params: {
    oldValue: string
    value: string
    cursor: number
    originalSelection: { start: number | null; end: number | null }
  }) => {
    const { oldValue, value, cursor, originalSelection } = params
    const offset = value.length - oldValue.length
    const selectionEnd = originalSelection.end ?? cursor - offset
    const selectionStart = originalSelection.start ?? originalSelection.end ?? cursor
    const firstNeedUpdateIndex = mentionList.value.findIndex(
      item => item.startIndex >= selectionEnd
    )
    const firstNeedRemoveIndex = getFirstNeedRemoveIndex({
      value: value,
      isDelete: offset < 0,
      selectionStart,
      cursor
    })
    const originalMentionList = mentionList.value
    let newMentionList = mentionList.value
    // 有后续mentionItem需要更新startIndex
    if (firstNeedUpdateIndex > -1) {
      newMentionList = [
        ...originalMentionList.slice(0, firstNeedRemoveIndex),
        ...originalMentionList.slice(firstNeedUpdateIndex).map(mention => {
          mention.startIndex = mention.startIndex + offset
          return mention
        })
      ]
    } else {
      newMentionList = originalMentionList.slice(0, firstNeedRemoveIndex)
    }
    mentionList.value = newMentionList
  }
  const getMentionList = () => {
    return mentionList.value
  }
  const resetMentionList = () => {
    mentionList.value = []
  }
  return {
    insertMentionUser,
    modifyMentionList,
    resetMentionList,
    shouldRemoveWholeMention,
    getMentionList
  }
}
